export const QL7_COMPOSER_CLIENT_LOCALE_HINTS = Object.freeze({
  "en": {
    "first": [
      "i ",
      "we "
    ],
    "operational": [
      "how to",
      "step by step",
      "instructions",
      "build a",
      "make a"
    ],
    "terror": [
      "terror",
      "terrorist"
    ],
    "explosive": [
      "bomb",
      "explosive",
      "detonator"
    ],
    "education": [
      "education",
      "educational",
      "history",
      "historical",
      "research",
      "study",
      "article"
    ],
    "victim": [
      "threatened me",
      "attacked me",
      "harassed me"
    ],
    "counter": [
      "do not attack",
      "do not kill",
      "condemn violence",
      "against terrorism"
    ],
    "temporal": [
      "now",
      "today",
      "tomorrow",
      "soon"
    ]
  },
  "ru": {
    "first": [
      "я ",
      "мы "
    ],
    "operational": [
      "как сделать",
      "как собрать",
      "пошагово",
      "инструкция"
    ],
    "terror": [
      "террор",
      "теракт",
      "террорист"
    ],
    "explosive": [
      "бомб",
      "взрывчат",
      "детонатор"
    ],
    "education": [
      "учеб",
      "образоват",
      "истори",
      "исслед",
      "статья"
    ],
    "victim": [
      "мне угрож",
      "меня атак",
      "меня преслед"
    ],
    "counter": [
      "не нападай",
      "не убивай",
      "осуждаю насилие",
      "против террор"
    ],
    "temporal": [
      "сейчас",
      "сегодня",
      "завтра",
      "скоро"
    ]
  },
  "uk": {
    "first": [
      "я ",
      "ми "
    ],
    "operational": [
      "як зробити",
      "як зібрати",
      "покроково",
      "інструкц"
    ],
    "terror": [
      "терор",
      "теракт",
      "терорист"
    ],
    "explosive": [
      "бомб",
      "вибухів",
      "детонатор"
    ],
    "education": [
      "навч",
      "освіт",
      "істор",
      "дослідж",
      "статт"
    ],
    "victim": [
      "мені погрож",
      "мене атак",
      "мене переслід"
    ],
    "counter": [
      "не нападай",
      "не вбивай",
      "засуджую насильство",
      "проти терор"
    ],
    "temporal": [
      "зараз",
      "сьогодні",
      "завтра",
      "скоро"
    ]
  },
  "es": {
    "first": [
      "yo ",
      "nosotros "
    ],
    "operational": [
      "cómo hacer",
      "como hacer",
      "paso a paso",
      "instrucciones",
      "cómo construir"
    ],
    "terror": [
      "terror",
      "terrorista",
      "atentado"
    ],
    "explosive": [
      "bomba",
      "explosivo",
      "detonador"
    ],
    "education": [
      "educación",
      "educativo",
      "historia",
      "investigación",
      "estudio",
      "artículo"
    ],
    "victim": [
      "me amenaz",
      "me atac",
      "me acos"
    ],
    "counter": [
      "no ataques",
      "no mates",
      "condeno la violencia",
      "contra el terrorismo"
    ],
    "temporal": [
      "ahora",
      "hoy",
      "mañana",
      "pronto"
    ]
  },
  "tr": {
    "first": [
      "ben ",
      "biz "
    ],
    "operational": [
      "nasıl yapılır",
      "nasıl yapılır",
      "adım adım",
      "talimat",
      "nasıl yapılır"
    ],
    "terror": [
      "terör",
      "terörist",
      "saldırı"
    ],
    "explosive": [
      "bomba",
      "patlayıcı",
      "detonatör"
    ],
    "education": [
      "eğitim",
      "tarih",
      "araştırma",
      "çalışma",
      "makale"
    ],
    "victim": [
      "beni tehdit",
      "bana saldır",
      "beni taciz"
    ],
    "counter": [
      "saldırma",
      "öldürme",
      "şiddeti kınıyorum",
      "teröre karşı"
    ],
    "temporal": [
      "şimdi",
      "bugün",
      "yarın",
      "yakında"
    ]
  },
  "ar": {
    "first": [
      "أنا ",
      "نحن "
    ],
    "operational": [
      "كيفية صنع",
      "كيف أصنع",
      "خطوة بخطوة",
      "تعليمات"
    ],
    "terror": [
      "إرهاب",
      "إرهابي",
      "هجوم إرهابي"
    ],
    "explosive": [
      "قنبلة",
      "متفجر",
      "صاعق"
    ],
    "education": [
      "تعليم",
      "تاريخ",
      "بحث",
      "دراسة",
      "مقال"
    ],
    "victim": [
      "هددني",
      "هاجمني",
      "يضايقني"
    ],
    "counter": [
      "لا تهاجم",
      "لا تقتل",
      "أدين العنف",
      "ضد الإرهاب"
    ],
    "temporal": [
      "الآن",
      "اليوم",
      "غدا",
      "قريبا"
    ]
  },
  "zh": {
    "first": [
      "我",
      "我们"
    ],
    "operational": [
      "怎么做",
      "如何制作",
      "一步一步",
      "操作说明"
    ],
    "terror": [
      "恐怖",
      "恐怖主义",
      "恐袭"
    ],
    "explosive": [
      "炸弹",
      "爆炸物",
      "雷管"
    ],
    "education": [
      "教育",
      "历史",
      "研究",
      "学习",
      "文章"
    ],
    "victim": [
      "威胁我",
      "攻击我",
      "骚扰我"
    ],
    "counter": [
      "不要攻击",
      "不要杀",
      "谴责暴力",
      "反对恐怖主义"
    ],
    "temporal": [
      "现在",
      "今天",
      "明天",
      "很快"
    ]
  },
  "he": {
    "first": [
      "אני ",
      "אנחנו "
    ],
    "operational": [
      "איך להכין",
      "כיצד להכין",
      "שלב אחר שלב",
      "הוראות"
    ],
    "terror": [
      "טרור",
      "מחבל",
      "פיגוע"
    ],
    "explosive": [
      "פצצה",
      "חומר נפץ",
      "נפץ"
    ],
    "education": [
      "חינוך",
      "היסטוריה",
      "מחקר",
      "לימוד",
      "מאמר"
    ],
    "victim": [
      "איימו עלי",
      "תקפו אותי",
      "הטרידו אותי"
    ],
    "counter": [
      "אל תתקוף",
      "אל תהרוג",
      "מגנה אלימות",
      "נגד טרור"
    ],
    "temporal": [
      "עכשיו",
      "היום",
      "מחר",
      "בקרוב"
    ]
  },
  "de": {
    "first": [
      "ich ",
      "wir "
    ],
    "operational": [
      "wie man",
      "wie baue",
      "schritt für schritt",
      "anleitung"
    ],
    "terror": [
      "terror",
      "terrorist",
      "anschlag"
    ],
    "explosive": [
      "bombe",
      "sprengstoff",
      "zünder"
    ],
    "education": [
      "bildung",
      "pädagog",
      "geschichte",
      "forschung",
      "studie",
      "artikel"
    ],
    "victim": [
      "bedrohte mich",
      "droht mir",
      "griff mich an",
      "belästigt mich"
    ],
    "counter": [
      "nicht angreifen",
      "nicht töten",
      "verurteile gewalt",
      "gegen terror"
    ],
    "temporal": [
      "jetzt",
      "heute",
      "morgen",
      "bald"
    ]
  },
  "fr": {
    "first": [
      "je ",
      "nous "
    ],
    "operational": [
      "comment faire",
      "comment fabriquer",
      "étape par étape",
      "instructions"
    ],
    "terror": [
      "terror",
      "terroriste",
      "attentat"
    ],
    "explosive": [
      "bombe",
      "explosif",
      "détonateur"
    ],
    "education": [
      "éducation",
      "éducatif",
      "histoire",
      "recherche",
      "étude",
      "article"
    ],
    "victim": [
      "me menace",
      "m’a menacé",
      "m attaque",
      "me harcèle"
    ],
    "counter": [
      "n attaque pas",
      "ne tue pas",
      "condamne la violence",
      "contre le terrorisme"
    ],
    "temporal": [
      "maintenant",
      "aujourd hui",
      "demain",
      "bientôt"
    ]
  },
  "it": {
    "first": [
      "io ",
      "noi "
    ],
    "operational": [
      "come fare",
      "come costruire",
      "passo dopo passo",
      "istruzioni"
    ],
    "terror": [
      "terror",
      "terrorista",
      "attentato"
    ],
    "explosive": [
      "bomba",
      "esplosivo",
      "detonatore"
    ],
    "education": [
      "educazione",
      "educativo",
      "storia",
      "ricerca",
      "studio",
      "articolo"
    ],
    "victim": [
      "mi minaccia",
      "mi ha minacciato",
      "mi attacca",
      "mi molesta"
    ],
    "counter": [
      "non attaccare",
      "non uccidere",
      "condanno la violenza",
      "contro il terrorismo"
    ],
    "temporal": [
      "ora",
      "oggi",
      "domani",
      "presto"
    ]
  },
  "pt": {
    "first": [
      "eu ",
      "nós "
    ],
    "operational": [
      "como fazer",
      "como construir",
      "passo a passo",
      "instruções"
    ],
    "terror": [
      "terror",
      "terrorista",
      "atentado"
    ],
    "explosive": [
      "bomba",
      "explosivo",
      "detonador"
    ],
    "education": [
      "educação",
      "educativo",
      "história",
      "pesquisa",
      "estudo",
      "artigo"
    ],
    "victim": [
      "me ameaçou",
      "me ameaça",
      "me atacou",
      "me assedia"
    ],
    "counter": [
      "não ataque",
      "não mate",
      "condeno a violência",
      "contra o terrorismo"
    ],
    "temporal": [
      "agora",
      "hoje",
      "amanhã",
      "em breve"
    ]
  },
  "pl": {
    "first": [
      "ja ",
      "my "
    ],
    "operational": [
      "jak zrobić",
      "jak zbudować",
      "krok po kroku",
      "instrukc"
    ],
    "terror": [
      "terror",
      "terroryst",
      "zamach"
    ],
    "explosive": [
      "bomba",
      "materiał wybuchowy",
      "detonator"
    ],
    "education": [
      "edukac",
      "histori",
      "badanie",
      "nauk",
      "artykuł"
    ],
    "victim": [
      "grozi mi",
      "zagroził mi",
      "zaatakował mnie",
      "nęka mnie"
    ],
    "counter": [
      "nie atakuj",
      "nie zabijaj",
      "potępiam przemoc",
      "przeciw terroryzmowi"
    ],
    "temporal": [
      "teraz",
      "dzisiaj",
      "jutro",
      "wkrótce"
    ]
  },
  "nl": {
    "first": [
      "ik ",
      "wij "
    ],
    "operational": [
      "hoe maak",
      "hoe bouw",
      "stap voor stap",
      "instructies"
    ],
    "terror": [
      "terror",
      "terrorist",
      "aanslag"
    ],
    "explosive": [
      "bom",
      "explosief",
      "ontsteker"
    ],
    "education": [
      "onderwijs",
      "educatief",
      "geschiedenis",
      "onderzoek",
      "studie",
      "artikel"
    ],
    "victim": [
      "bedreigt mij",
      "bedreigde mij",
      "viel mij aan",
      "valt mij lastig"
    ],
    "counter": [
      "niet aanvallen",
      "niet doden",
      "veroordeel geweld",
      "tegen terrorisme"
    ],
    "temporal": [
      "nu",
      "vandaag",
      "morgen",
      "binnenkort"
    ]
  },
  "sv": {
    "first": [
      "jag ",
      "vi "
    ],
    "operational": [
      "hur man gör",
      "hur bygger",
      "steg för steg",
      "instruktion"
    ],
    "terror": [
      "terror",
      "terrorist",
      "attentat"
    ],
    "explosive": [
      "bomb",
      "sprängämne",
      "detonator"
    ],
    "education": [
      "utbildning",
      "historia",
      "forskning",
      "studie",
      "artikel"
    ],
    "victim": [
      "hotar mig",
      "hotade mig",
      "attackerade mig",
      "trakasserar mig"
    ],
    "counter": [
      "attackera inte",
      "döda inte",
      "fördömer våld",
      "mot terrorism"
    ],
    "temporal": [
      "nu",
      "idag",
      "imorgon",
      "snart"
    ]
  },
  "no": {
    "first": [
      "jeg ",
      "vi "
    ],
    "operational": [
      "hvordan lage",
      "hvordan bygge",
      "steg for steg",
      "instruksjon"
    ],
    "terror": [
      "terror",
      "terrorist",
      "angrep"
    ],
    "explosive": [
      "bombe",
      "sprengstoff",
      "detonator"
    ],
    "education": [
      "utdanning",
      "historie",
      "forskning",
      "studie",
      "artikkel"
    ],
    "victim": [
      "truer meg",
      "truet meg",
      "angrep meg",
      "trakasserer meg"
    ],
    "counter": [
      "ikke angrip",
      "ikke drep",
      "fordømmer vold",
      "mot terrorisme"
    ],
    "temporal": [
      "nå",
      "i dag",
      "i morgen",
      "snart"
    ]
  },
  "da": {
    "first": [
      "jeg ",
      "vi "
    ],
    "operational": [
      "hvordan laver",
      "hvordan bygger",
      "trin for trin",
      "instruktion"
    ],
    "terror": [
      "terror",
      "terrorist",
      "angreb"
    ],
    "explosive": [
      "bombe",
      "sprængstof",
      "detonator"
    ],
    "education": [
      "uddannelse",
      "historie",
      "forskning",
      "studie",
      "artikel"
    ],
    "victim": [
      "truer mig",
      "truede mig",
      "angreb mig",
      "chikanerer mig"
    ],
    "counter": [
      "angrib ikke",
      "dræb ikke",
      "fordømmer vold",
      "mod terrorisme"
    ],
    "temporal": [
      "nu",
      "i dag",
      "i morgen",
      "snart"
    ]
  },
  "fi": {
    "first": [
      "minä ",
      "me "
    ],
    "operational": [
      "miten tehdä",
      "miten rakentaa",
      "vaihe vaiheelta",
      "ohje"
    ],
    "terror": [
      "terror",
      "terroristi",
      "isku"
    ],
    "explosive": [
      "pommi",
      "räjähde",
      "nall"
    ],
    "education": [
      "koulutus",
      "historia",
      "tutkimus",
      "opiskelu",
      "artikkeli"
    ],
    "victim": [
      "uhkaa minua",
      "uhkasi minua",
      "hyökkäsi kimppuuni",
      "häiritsee minua"
    ],
    "counter": [
      "älä hyökkää",
      "älä tapa",
      "tuomitsen väkivallan",
      "terrorismia vastaan"
    ],
    "temporal": [
      "nyt",
      "tänään",
      "huomenna",
      "pian"
    ]
  },
  "cs": {
    "first": [
      "já ",
      "my "
    ],
    "operational": [
      "jak udělat",
      "jak postavit",
      "krok za krokem",
      "návod"
    ],
    "terror": [
      "teror",
      "terorista",
      "útok"
    ],
    "explosive": [
      "bomba",
      "výbušnina",
      "rozbuška"
    ],
    "education": [
      "vzděláv",
      "historie",
      "výzkum",
      "studie",
      "článek"
    ],
    "victim": [
      "vyhrožuje mi",
      "vyhrožoval mi",
      "napadl mě",
      "obtěžuje mě"
    ],
    "counter": [
      "neútoč",
      "nezabíjej",
      "odsuzuji násilí",
      "proti terorismu"
    ],
    "temporal": [
      "teď",
      "dnes",
      "zítra",
      "brzy"
    ]
  },
  "sk": {
    "first": [
      "ja ",
      "my "
    ],
    "operational": [
      "ako urobiť",
      "ako postaviť",
      "krok za krokom",
      "návod"
    ],
    "terror": [
      "teror",
      "terorista",
      "útok"
    ],
    "explosive": [
      "bomba",
      "výbušnina",
      "rozbuška"
    ],
    "education": [
      "vzdeláv",
      "história",
      "výskum",
      "štúdia",
      "článok"
    ],
    "victim": [
      "vyhráža sa mi",
      "vyhrážal mi",
      "napadol ma",
      "obťažuje ma"
    ],
    "counter": [
      "neútoč",
      "nezabíjaj",
      "odsudzujem násilie",
      "proti terorizmu"
    ],
    "temporal": [
      "teraz",
      "dnes",
      "zajtra",
      "čoskoro"
    ]
  },
  "hu": {
    "first": [
      "én ",
      "mi "
    ],
    "operational": [
      "hogyan készíts",
      "hogyan építs",
      "lépésről lépésre",
      "utasítás"
    ],
    "terror": [
      "terror",
      "terrorista",
      "merénylet"
    ],
    "explosive": [
      "bomba",
      "robbanóanyag",
      "detonátor"
    ],
    "education": [
      "oktatás",
      "történelem",
      "kutatás",
      "tanulmány",
      "cikk"
    ],
    "victim": [
      "megfenyegetett",
      "fenyeget engem",
      "megtámadott",
      "zaklat engem"
    ],
    "counter": [
      "ne támadj",
      "ne ölj",
      "elítélem az erőszakot",
      "terrorizmus ellen"
    ],
    "temporal": [
      "most",
      "ma",
      "holnap",
      "hamarosan"
    ]
  },
  "ro": {
    "first": [
      "eu ",
      "noi "
    ],
    "operational": [
      "cum să faci",
      "cum sa faci",
      "pas cu pas",
      "instrucțiuni"
    ],
    "terror": [
      "teror",
      "terorist",
      "atentat"
    ],
    "explosive": [
      "bombă",
      "exploziv",
      "detonator"
    ],
    "education": [
      "educaț",
      "istorie",
      "cercetare",
      "studiu",
      "articol"
    ],
    "victim": [
      "mă amenință",
      "m-a amenințat",
      "m-a atacat",
      "mă hărțuiește"
    ],
    "counter": [
      "nu ataca",
      "nu ucide",
      "condamn violența",
      "împotriva terorismului"
    ],
    "temporal": [
      "acum",
      "astăzi",
      "mâine",
      "curând"
    ]
  },
  "bg": {
    "first": [
      "аз ",
      "ние "
    ],
    "operational": [
      "как да направя",
      "как да построя",
      "стъпка по стъпка",
      "инструкц"
    ],
    "terror": [
      "терор",
      "терорист",
      "атентат"
    ],
    "explosive": [
      "бомба",
      "взрив",
      "детонатор"
    ],
    "education": [
      "образован",
      "истор",
      "изследван",
      "проучван",
      "статия"
    ],
    "victim": [
      "заплашва ме",
      "заплаши ме",
      "нападна ме",
      "тормози ме"
    ],
    "counter": [
      "не нападай",
      "не убивай",
      "осъждам насилието",
      "против тероризма"
    ],
    "temporal": [
      "сега",
      "днес",
      "утре",
      "скоро"
    ]
  },
  "sr": {
    "first": [
      "ja ",
      "mi "
    ],
    "operational": [
      "kako napraviti",
      "kako izgraditi",
      "korak po korak",
      "uputstvo"
    ],
    "terror": [
      "teror",
      "terorista",
      "napad"
    ],
    "explosive": [
      "bomba",
      "eksploziv",
      "detonator"
    ],
    "education": [
      "obrazov",
      "istor",
      "istraživ",
      "studija",
      "članak"
    ],
    "victim": [
      "preti mi",
      "pretio mi",
      "napao me",
      "uznemirava me"
    ],
    "counter": [
      "ne napadaj",
      "ne ubijaj",
      "osuđujem nasilje",
      "protiv terorizma"
    ],
    "temporal": [
      "sada",
      "danas",
      "sutra",
      "uskoro"
    ]
  },
  "hr": {
    "first": [
      "ja ",
      "mi "
    ],
    "operational": [
      "kako napraviti",
      "kako izgraditi",
      "korak po korak",
      "upute"
    ],
    "terror": [
      "teror",
      "terorist",
      "napad"
    ],
    "explosive": [
      "bomba",
      "eksploziv",
      "detonator"
    ],
    "education": [
      "obrazov",
      "povijest",
      "istraživ",
      "studija",
      "članak"
    ],
    "victim": [
      "prijeti mi",
      "prijetio mi",
      "napao me",
      "uznemirava me"
    ],
    "counter": [
      "ne napadaj",
      "ne ubijaj",
      "osuđujem nasilje",
      "protiv terorizma"
    ],
    "temporal": [
      "sada",
      "danas",
      "sutra",
      "uskoro"
    ]
  },
  "sl": {
    "first": [
      "jaz ",
      "mi "
    ],
    "operational": [
      "kako narediti",
      "kako izdelati",
      "korak za korakom",
      "navodila"
    ],
    "terror": [
      "teror",
      "terorist",
      "napad"
    ],
    "explosive": [
      "bomba",
      "eksploziv",
      "detonator"
    ],
    "education": [
      "izobraž",
      "zgodovin",
      "raziskav",
      "študija",
      "članek"
    ],
    "victim": [
      "grozi mi",
      "mi je grozil",
      "napadel me",
      "nadleguje me"
    ],
    "counter": [
      "ne napadaj",
      "ne ubijaj",
      "obsojam nasilje",
      "proti terorizmu"
    ],
    "temporal": [
      "zdaj",
      "danes",
      "jutri",
      "kmalu"
    ]
  },
  "el": {
    "first": [
      "εγώ ",
      "εμείς "
    ],
    "operational": [
      "πώς να φτιάξω",
      "πως να φτιαξω",
      "βήμα προς βήμα",
      "οδηγίες"
    ],
    "terror": [
      "τρομοκρατ",
      "τρομοκράτ",
      "επίθεση"
    ],
    "explosive": [
      "βόμβα",
      "εκρηκτικό",
      "πυροκροτητή"
    ],
    "education": [
      "εκπαίδευ",
      "ιστορ",
      "έρευνα",
      "μελέτη",
      "άρθρο"
    ],
    "victim": [
      "με απειλεί",
      "με απείλησε",
      "μου επιτέθηκε",
      "με παρενοχλεί"
    ],
    "counter": [
      "μην επιτεθείς",
      "μη σκοτώσεις",
      "καταδικάζω τη βία",
      "κατά της τρομοκρατίας"
    ],
    "temporal": [
      "τώρα",
      "σήμερα",
      "αύριο",
      "σύντομα"
    ]
  },
  "ka": {
    "first": [
      "მე ",
      "ჩვენ "
    ],
    "operational": [
      "როგორ გავაკეთო",
      "როგორ ავაწყო",
      "ნაბიჯ-ნაბიჯ",
      "ინსტრუქცია"
    ],
    "terror": [
      "ტერორ",
      "ტერორისტ",
      "თავდასხმა"
    ],
    "explosive": [
      "ბომბი",
      "ასაფეთქებელი",
      "დეტონატორი"
    ],
    "education": [
      "განათლებ",
      "ისტორია",
      "კვლევა",
      "შესწავლა",
      "სტატია"
    ],
    "victim": [
      "მემუქრება",
      "დამემუქრა",
      "თავს დამესხა",
      "მავიწროებს"
    ],
    "counter": [
      "არ დაესხა",
      "არ მოკლა",
      "ვგმობ ძალადობას",
      "ტერორიზმის წინააღმდეგ"
    ],
    "temporal": [
      "ახლა",
      "დღეს",
      "ხვალ",
      "მალე"
    ]
  },
  "az": {
    "first": [
      "mən ",
      "biz "
    ],
    "operational": [
      "necə etmək",
      "necə düzəltmək",
      "addım-addım",
      "təlimat"
    ],
    "terror": [
      "terror",
      "terrorçu",
      "hücum"
    ],
    "explosive": [
      "bomba",
      "partlayıcı",
      "detonator"
    ],
    "education": [
      "təhsil",
      "tarix",
      "araşdırma",
      "tədqiqat",
      "məqalə"
    ],
    "victim": [
      "məni hədələyir",
      "məni hədələdi",
      "mənə hücum etdi",
      "məni təqib edir"
    ],
    "counter": [
      "hücum etmə",
      "öldürmə",
      "zorakılığı qınayıram",
      "terrorizmə qarşı"
    ],
    "temporal": [
      "indi",
      "bu gün",
      "sabah",
      "tezliklə"
    ]
  },
  "kk": {
    "first": [
      "мен ",
      "біз "
    ],
    "operational": [
      "қалай жасау",
      "қалай құрастыру",
      "қадам бойынша",
      "нұсқаулық"
    ],
    "terror": [
      "террор",
      "террорист",
      "шабуыл"
    ],
    "explosive": [
      "бомба",
      "жарылғыш",
      "детонатор"
    ],
    "education": [
      "білім",
      "тарих",
      "зерттеу",
      "зерттеме",
      "мақала"
    ],
    "victim": [
      "маған қауіп төндір",
      "мені қорқыт",
      "маған шабуыл жасады",
      "мені қудалайды"
    ],
    "counter": [
      "шабуыл жасама",
      "өлтірме",
      "зорлықты айыптаймын",
      "терроризмге қарсымын"
    ],
    "temporal": [
      "қазір",
      "бүгін",
      "ертең",
      "жақында"
    ]
  },
  "ja": {
    "first": [
      "私",
      "僕",
      "俺",
      "私たち"
    ],
    "operational": [
      "作り方",
      "どうやって作る",
      "手順",
      "ステップバイステップ"
    ],
    "terror": [
      "テロ",
      "テロリスト",
      "テロ攻撃"
    ],
    "explosive": [
      "爆弾",
      "爆発物",
      "起爆装置"
    ],
    "education": [
      "教育",
      "歴史",
      "研究",
      "学習",
      "記事"
    ],
    "victim": [
      "脅された",
      "私を脅",
      "襲われた",
      "嫌がらせ"
    ],
    "counter": [
      "攻撃しないで",
      "殺さないで",
      "暴力を非難",
      "テロに反対"
    ],
    "temporal": [
      "今",
      "今日",
      "明日",
      "すぐ"
    ]
  },
  "ko": {
    "first": [
      "나 ",
      "저 ",
      "우리 "
    ],
    "operational": [
      "만드는 법",
      "어떻게 만들",
      "단계별",
      "지침"
    ],
    "terror": [
      "테러",
      "테러리스트",
      "테러 공격"
    ],
    "explosive": [
      "폭탄",
      "폭발물",
      "기폭장치"
    ],
    "education": [
      "교육",
      "역사",
      "연구",
      "학습",
      "기사"
    ],
    "victim": [
      "나를 위협",
      "협박받",
      "공격받",
      "괴롭힘"
    ],
    "counter": [
      "공격하지 마",
      "죽이지 마",
      "폭력을 규탄",
      "테러에 반대"
    ],
    "temporal": [
      "지금",
      "오늘",
      "내일",
      "곧"
    ]
  }
})

function fold(value=''){return String(value||'').normalize('NFKC').toLocaleLowerCase().replace(/[’]/gu,"'").replace(/\s+/gu,' ').trim()}
function hasAny(text,terms=[]){const value=fold(text),tokens=new Set(value.match(/[\p{L}\p{N}_'-]+/gu)||[]);return terms.some((term)=>{const v=fold(term);if(!v)return false;if(!/[\u3040-\u30ff\u3400-\u9fff\uac00-\ud7af]/u.test(v)&&!v.includes(' ')&&Array.from(v).length<=3)return tokens.has(v);return value.includes(v)})}
function hasCounter(text,terms=[]){const value=fold(text),tokens=new Set(value.match(/[\p{L}\p{N}_'-]+/gu)||[]);return terms.some((term)=>{const v=fold(term);if(!v)return false;if(/[\u3040-\u30ff\u3400-\u9fff\uac00-\ud7af]/u.test(v)||v.includes(' '))return value.includes(v);return tokens.has(v)})}
export function matchComposerClientLocaleHints(text='',locale='en'){const id=String(locale||'en').toLowerCase().split(/[-_]/u)[0];const row=QL7_COMPOSER_CLIENT_LOCALE_HINTS[id]||QL7_COMPOSER_CLIENT_LOCALE_HINTS.en;return Object.freeze({locale:id,firstPerson:hasCounter(text,row.first),operational:hasAny(text,row.operational),terror:hasAny(text,row.terror),explosive:hasAny(text,row.explosive),education:hasAny(text,row.education),victim:hasAny(text,row.victim),counter:hasCounter(text,row.counter),temporal:hasAny(text,row.temporal)})}
